import React from "react";
import { marqueeDesserts } from "../../data/images";
export function DessertMarquee() {
  const items = [...marqueeDesserts, ...marqueeDesserts];
  return <section aria-label="Algunos postres del pack" className="overflow-hidden border-y border-blush-dark/40 bg-blush py-6" data-id="element-599" data-mp="3t3oxyuct64ts">
      <div className="animate-marquee flex w-max gap-5" data-id="element-600" data-mp="5sh1o9ik25cf">
        {items.map((d, i) => <figure key={i} className="w-44 shrink-0 rounded-2xl bg-white p-2 shadow-md sm:w-52" aria-hidden={i >= marqueeDesserts.length} data-id="element-601" data-mp="arsjllunrgvl" data-mpi={i}>
            <img src={d.src} alt={d.name} className="aspect-[4/3] w-full rounded-xl object-cover" loading="lazy" data-id="element-602" data-mp="fpu48b7qfo96" />
            <figcaption className="px-1 pt-2 text-center text-sm font-semibold text-cocoa" data-id="element-603" data-mp="kqhsip4ktqzp">{d.name}</figcaption>
          </figure>)}
      </div>
    </section>;
}